// extracted by mini-css-extract-plugin
export default {"column":"RiskKycRulesEditModal_column__G-Oz9"};